var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", [
    _c("div", [
      _c(
        "div",
        [
          [
            _vm.products == null ||
            _vm.products.length == 0 ||
            _vm.isContinueContract()
              ? _c(
                  "div",
                  [
                    _vm.isContinueContract()
                      ? [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("Jatketaan entisellä tuotteella")) +
                              "\n                    "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("Ei valittavissa olevia tuotteita")
                              ) +
                              "\n                    "
                          )
                        ]
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.products, function(product) {
              return _c("div", { staticClass: "product" }, [
                (_vm.preSelectedProductId == null ||
                  (_vm.preSelectedProductId > 0 &&
                    _vm.preSelectedProductId == product.Id)) &&
                _vm.isContinueContract() == false
                  ? _c("div", { staticClass: "card flex-nowrap" }, [
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", { attrs: { sm: "6", lg: "3" } }, [
                                product.Icon
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "text-center product-image"
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "product-icon m-2",
                                          attrs: {
                                            alt: product.Name,
                                            src:
                                              "/Content/PKS/images/" +
                                              product.Icon
                                          }
                                        })
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("b-col", { attrs: { sm: "6", lg: "3" } }, [
                                _c(
                                  "p",
                                  { staticClass: "product-description" },
                                  [_vm._v(_vm._s(product.ShortDescription))]
                                )
                              ]),
                              _vm._v(" "),
                              product.PriceLists.length > 1
                                ? [
                                    _vm.preSelectedPriceListId == null
                                      ? [
                                          _c(
                                            "b-tabs",
                                            {
                                              staticClass:
                                                "col-sm-12 col-lg-6 price-list-tabs"
                                            },
                                            _vm._l(product.PriceLists, function(
                                              priceList
                                            ) {
                                              return _c(
                                                "b-tab",
                                                {
                                                  key: priceList.text,
                                                  attrs: { data: priceList },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "title",
                                                        fn: function() {
                                                          return [
                                                            _c("b", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  priceList.Name
                                                                )
                                                              )
                                                            ])
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c("price-list", {
                                                    attrs: {
                                                      "price-list": priceList,
                                                      showVat:
                                                        _vm.showPricesWithVat,
                                                      "is-selected": _vm.isSelected(
                                                        product,
                                                        priceList
                                                      ),
                                                      "product-id": product.Id
                                                    },
                                                    on: {
                                                      selected: function(
                                                        $event
                                                      ) {
                                                        return _vm.selectClicked(
                                                          product,
                                                          priceList
                                                        )
                                                      }
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.preSelectedPriceListId > 0 &&
                                    _vm.preSelectedPriceListId ==
                                      product.PriceLists[0].Id
                                      ? [
                                          _c("price-list", {
                                            attrs: {
                                              sm: "12",
                                              lg: "6",
                                              "price-list":
                                                product.PriceLists[0],
                                              showVat: _vm.showPricesWithVat,
                                              "is-selected": _vm.isSelected(
                                                product,
                                                product.PriceLists[0]
                                              ),
                                              "product-id": product.Id
                                            },
                                            on: {
                                              selected: function($event) {
                                                return _vm.selectClicked(
                                                  product,
                                                  product.PriceLists[0]
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              product.PriceLists.length == 1
                                ? [
                                    _c("price-list", {
                                      staticClass: "col-sm-12 col-lg-6",
                                      attrs: {
                                        "price-list": product.PriceLists[0],
                                        showVat: _vm.showPricesWithVat,
                                        "is-selected": _vm.isSelected(
                                          product,
                                          product.PriceLists[0]
                                        ),
                                        "product-id": product.Id
                                      },
                                      on: {
                                        selected: function($event) {
                                          return _vm.selectClicked(
                                            product,
                                            product.PriceLists[0]
                                          )
                                        }
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.isPriimaPlusProduct(product.Id) ||
                          _vm.isPriimaProduct(product.Id)
                            ? _c(
                                "b-row",
                                [
                                  _c("b-col", { attrs: { md: "12" } }, [
                                    _vm.isPriimaPlusProduct(product.Id)
                                      ? _c("p", [
                                          _vm._v(
                                            "Kun olet kiinnittänyt sähkön hinnan jollekin aikavälille, voit vielä vaikuttaa toteutuvaan laskutushintaan sen mukaan, kuinka sähkönkäyttösi on jakaantunut halvimpien ja kalliimpien tuntihintojen kesken."
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          product.Description
                            ? _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-md-12" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "card card-default product-details"
                                    },
                                    [
                                      _c("div", { staticClass: "card-body" }, [
                                        _c(
                                          "h4",
                                          {
                                            staticClass:
                                              "card-title text-center"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  role: "button",
                                                  "data-toggle": "collapse",
                                                  href:
                                                    "#product-details-" +
                                                    product.Id,
                                                  "aria-expanded": "true"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "Lisätietoja tuotteesta"
                                                      )
                                                    ) +
                                                    "\n                                                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "collapse",
                                          attrs: {
                                            id: "product-details-" + product.Id,
                                            role: "tabpanel"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-body" },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(product.Description) +
                                                  "\n                                            "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            })
          ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }